import React, { SyntheticEvent, useState } from "react";
import { Box, Paper, Tab, Tabs, Typography } from "@mui/material";
import AdminDashboardLayout from "../../../layouts/admin_dashboard_layout/admin_dashboard_layout";
import YoucatPageSettingsTab from "./youcat_page_settings_tab";
import YoucatMonthlyMaterialsTab from "./youcat_monthly_materials_tab";
import YoucatMonthlyFormTab from "./youcat_monthly_form_tab";
import YoucatResponsesTab from "./youcat_responses_tab";
import YoucatQuizTab from "./youcat_quiz_tab";

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`youcat-tabpanel-${index}`}
      aria-labelledby={`youcat-tab-${index}`}
      {...other}
    >
      {value === index ? <Box>{children}</Box> : null}
    </div>
  );
}

export default function YoucatAdminPage() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleChange = (_event: SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <AdminDashboardLayout>
      <Box sx={{ p: { xs: 1, md: 2 } }}>
        <Paper
          elevation={0}
          sx={{
            borderRadius: 4,
            overflow: "visible",
            border: "1px solid rgba(217,119,6,0.12)",
            boxShadow: "0 20px 48px rgba(180, 120, 20, 0.08)",
          }}
        >
          <Box
            sx={{
              px: { xs: 2, md: 3 },
              py: { xs: 2, md: 2.5 },
              background:
                "linear-gradient(135deg, rgba(255,247,237,1) 0%, rgba(255,255,255,1) 100%)",
              borderBottom: "1px solid rgba(217,119,6,0.12)",
            }}
          >
            <Typography variant="overline" fontWeight={800} color="#b45309">
              YOUCAT ADMIN
            </Typography>
            <Typography variant="h5" fontWeight={800}>
              Monthly content, form, and response management
            </Typography>
          </Box>
          <Box sx={{ borderBottom: 1, borderColor: "divider", px: { xs: 1, md: 2 } }}>
            <Tabs
              value={currentTab}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons="auto"
              aria-label="youcat management tabs"
              sx={{
                minHeight: 64,
                "& .MuiTab-root": {
                  minHeight: 64,
                  textTransform: "none",
                  fontWeight: 700,
                },
              }}
            >
              <Tab label="Page Content" id="youcat-tab-0" />
              <Tab label="Monthly Material" id="youcat-tab-1" />
              <Tab label="Monthly Form" id="youcat-tab-2" />
              <Tab label="Responses & Excel" id="youcat-tab-3" />
              <Tab label="Quiz" id="youcat-tab-4" />
            </Tabs>
          </Box>
          <TabPanel value={currentTab} index={0}>
            <YoucatPageSettingsTab />
          </TabPanel>
          <TabPanel value={currentTab} index={1}>
            <YoucatMonthlyMaterialsTab />
          </TabPanel>
          <TabPanel value={currentTab} index={2}>
            <YoucatMonthlyFormTab />
          </TabPanel>
          <TabPanel value={currentTab} index={3}>
            <YoucatResponsesTab />
          </TabPanel>
          <TabPanel value={currentTab} index={4}>
            <YoucatQuizTab />
          </TabPanel>
        </Paper>
      </Box>
    </AdminDashboardLayout>
  );
}
